import React from 'react';

export const NoAuth = () => {
  const text = 'No Auth';

  return <h1>{text}</h1>;
};
